import React from 'react';
import { CheckIcon } from 'lucide-react';
import { brand, products } from '../data/content';
export function Solution() {
  return <section className="w-full bg-stone-50 py-16 md:py-24" data-id="element-138" data-mp="1ek2qdw84afyp">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-139" data-mp="10tpjlx6yp7ay">
        <header className="mx-auto max-w-3xl text-center" data-id="element-140" data-mp="10r385mgya7ng">
          <p className="text-xs font-extrabold uppercase tracking-widest text-pink-700" data-id="element-141" data-mp="15r8xux3ntk2w">
            La solution
          </p>
          <h2 className="mt-4 text-3xl font-extrabold leading-tight tracking-tight text-neutral-800 md:text-5xl" data-id="element-142" data-mp="qtov7wu8k0zw">
            Votre animation Octobre Rose, déjà structurée
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-lg text-neutral-500 md:text-xl" data-id="element-143" data-mp="hvwgatsfevd1">
            Le <span className="font-extrabold text-neutral-800" data-id="element-144" data-mp="mu7q54iq15v9">{brand.name}</span> n’est pas
            simplement un ensemble de PDF. C’est une boîte à outils conçue pour vous aider à
            préparer, organiser et animer un temps de sensibilisation autour d’Octobre Rose.
          </p>
          <p className="mx-auto mt-4 max-w-2xl text-lg text-neutral-500 md:text-xl" data-id="element-145" data-mp="6zp64y4hozmt">
            Vous disposez des supports, des activités, des messages, des idées… et d’un guide
            concret pour savoir comment les utiliser.
          </p>
        </header>

        <div className="mt-14 space-y-14 md:mt-16 md:space-y-20" data-id="element-146" data-mp="brqnuzkffik8">
          {products.map((product, index) => <article key={product.title} className="grid items-center gap-8 lg:grid-cols-2 lg:gap-14" data-id="element-147" data-mp="3k6quw5oezqfg" data-mpi={index}>
              <div className={index % 2 === 1 ? 'lg:order-2' : ''} data-id="element-148" data-mp="3g6gqgxg9t82p">
                <p className="inline-flex items-center gap-2 rounded-full bg-pink-900 px-4 py-1.5 text-xs font-extrabold uppercase tracking-widest text-pink-100" data-id="element-149" data-mp="3u5gdk0o4xewr">
                  {product.eyebrow}
                </p>
                <h3 className="mt-5 text-2xl font-extrabold leading-tight tracking-tight text-neutral-800 md:text-4xl" data-id="element-150" data-mp="19epo1kabv8mv">
                  {product.title}
                </h3>
                <p className="mt-4 text-lg font-bold leading-snug text-neutral-600 md:text-xl" data-id="element-151" data-mp="14iijnvxky571">
                  {product.lead}
                </p>
                {product.body && <p className="mt-4 text-lg leading-relaxed text-neutral-500" data-id="element-152" data-mp="1gkicg48qbwbc">{product.body}</p>}
                {product.points && <ul className="mt-5 space-y-2.5" data-id="element-153" data-mp="1qgv3svgsxy2x">
                    {product.points.map(point => <li key={point} className="flex items-start gap-3 text-neutral-600" data-id="element-154" data-mp="stw92q9o707o">
                        <CheckIcon className="mt-1.5 h-4 w-4 shrink-0 text-green-600" aria-hidden="true" data-id="element-155" data-mp="xszc6563awd0" />
                        <span data-id="element-156" data-mp="17i95tpgl0n38">{point}</span>
                      </li>)}
                  </ul>}
                <p className="mt-6 border-l-2 border-amber-400 pl-4 text-lg font-extrabold tracking-tight text-pink-900" data-id="element-157" data-mp="a1k6c2f3twx0">
                  {product.kicker}
                </p>
              </div>

              <div className={`space-y-5 ${index % 2 === 1 ? 'lg:order-1' : ''}`} data-id="element-158" data-mp="7gm7yn8mqerr">
                {product.images.map(image => <img key={image.src} src={image.src} alt={image.alt} className="w-full rounded-3xl shadow-xl" width={1200} height={900} data-id="element-159" data-mp="2gzse75bwmfs" />)}
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}